import type { LogoValue } from '../types';

export function matchByDomain(
  items: LogoValue[],
  hostname: string
): LogoValue | undefined {
  const normalizedHostname = hostname.toLowerCase();
  return items.find(
    (item) =>
      item.domain != null && item.domain.toLowerCase() === normalizedHostname
  );
}
